import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nxt-excel-editing',
  templateUrl: './excel-editing.component.html',
  styleUrls: ['./excel-editing.component.scss'],
})
export class ExcelEditingComponent implements OnInit {
  
  constructor() { }

  ngOnInit(): void { }
  
}
